/**
 * The PLAIN logo mark wherever the page says "expert" outside the ledger: the one-brain circle and the
 * infrastructure node own an animated mark with NO face (breathe 1 → 1.03 at 3s, an ear twitch every
 * ~6s; thinking dots while connector dots flow in; the speaking glow while they flow out). It is the
 * section's own mark, not a character: it never moves, never speaks. The face belongs to Foxy inside
 * the ledger pane only.
 */
import { useRef } from 'react';
import { Foxy } from './Foxy';
import type { PresenterState } from './CharacterPresenter';

export function FoxyMark({ size, state = 'listening', levelRef }: { size: number; state?: PresenterState; levelRef?: React.RefObject<number> }) {
  const own = useRef(0.3);
  return (
    <span className="fx-foxy-mark" style={{ width: size, height: size }} aria-hidden="true" data-state={state}>
      <Foxy state={state} levelRef={levelRef ?? own} size={size} persona={{ breath: 3 }} face="none" />
    </span>
  );
}
